import { actions } from "../../Redux/store";

type PathHandler = {
  pattern: RegExp;
  handle: (match: RegExpMatchArray, navigate: (path: string) => void) => void;
};

export const pathHandlers: PathHandler[] = [
  {
    pattern: /^toolbox\/rankings\/([^/]+)$/,
    handle: ([, playerId], navigate) => {
      navigate("/toolbox");
      actions.modal.openPlayerRankingModal(null);
      actions.modal.openPlayerProfileModal({ playerId });
    },
  },
  {
    pattern: /^toolbox\/rankings$/,
    handle: (_, navigate) => {
      navigate("/toolbox");
      actions.modal.openPlayerRankingModal(null);
    },
  },
  {
    pattern: /^artical\/([^/]+)$/,
    handle: ([, articleId], navigate) => {
      navigate("/news");
      actions.modal.openNewsDetailsModal({ article_id: articleId });
    },
  },
];

export const handlePath = (path: string, navigate: (path: string) => void): void => {
  const matchHandler = pathHandlers.find(({ pattern }) => pattern.test(path));

  if (matchHandler) {
    const match = path.match(matchHandler.pattern);
    if (match) {
      matchHandler.handle(match, navigate);
      return;
    }
  }

  console.warn("No matching route for:", path);
  navigate(path);
};
